import React from 'react'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import PropTypes from 'prop-types'

const NavigationControls = (props) => {
  
  const { matrixData, setCurrentId, optionSelectionId, setOptionSelectionId, setChecked, addToLogs, removeLogs, pageLog, removeFromPageLog, setAddingToPageLog } = useStore(state =>({
    matrixData: state.matrixData,
    setCurrentId: state.setCurrentId,
    optionSelectionId: state.optionSelectionId,
    setOptionSelectionId: state.setOptionSelectionId,
    addToLogs: state.addToLogs,
    removeLogs: state.removeLogs,
    setChecked: state.setChecked,
    pageLog: state.pageLog,
    removeFromPageLog: state.removeFromPageLog,
    setAddingToPageLog: state.setAddingToPageLog,
  }), shallow);

  // hide prev if start page
  const startPage = matrixData['startPage'] === props.pageId ? true : false;

  // option selected, enable the continue/next button
  const optionSelected = !optionSelectionId ? true : false;

  const { question_summary, question, next_text, prev_text } = matrixData['pages'][props.pageId];

  const summaryQuestion = question_summary || question;

  
  const nextClick = () => {
    const answerSelected = matrixData['pages'][optionSelectionId]['option_displayed_on_parent'] ;
    addToLogs(summaryQuestion, answerSelected);
    setCurrentId(optionSelectionId);
    
    // GTM tracking of question pages
    let answer = matrixData['pages'][optionSelectionId]['option_displayed_on_parent']; 
    window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 
      event: 'nwstQuestionLogEvent', 
      tracking: {
        event: 'nwstQuestionLog', 
        nwstQuestionPage: `${props.pageName} - ${props.pageId}`, 
        nwstQuestionPageAnswer: answer 
      }
    }); 
    setAddingToPageLog(true);

    setOptionSelectionId('');
    setChecked('');

  }
  
  const prevClick = () => {
    setAddingToPageLog(false);
    removeLogs();
    setChecked('');
    setOptionSelectionId('');

    removeFromPageLog();
    const prevPageIndex = pageLog.length - 2;
    const prevPageId = pageLog[prevPageIndex];
    setCurrentId(prevPageId)

    // setCurrentId(parentPageId);
  }

  return (
    <div className="navigation-controls">

      <button onClick={prevClick} className={`swt-button navigation-controls--prev ${startPage ? "hide-control" : ""}`}>
        <div>{prev_text}</div>
      </button>
      
      <button disabled={optionSelected} onClick={nextClick} className="swt-button navigation-controls--next">
        <div>{next_text}</div>
      </button>
    </div>
  )
}

NavigationControls.propTypes = {
  pageId: PropTypes.string,
  pageName: PropTypes.string
}

export default NavigationControls;